"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var devtools_1 = require("react-query/devtools");
var react_router_dom_1 = require("react-router-dom");
var scroll_to_top_1 = __importDefault(require("../checkout/components/scroll-to-top"));
var app_1 = __importDefault(require("../returns/app"));
var account_page_1 = __importDefault(require("./account-page"));
var api_1 = require("./api");
var bundle_components_1 = __importDefault(require("./bundle-components"));
var callout_1 = require("./components/callout");
var inline_loader_1 = __importDefault(require("./components/inline_loader"));
var url_modal_1 = __importDefault(require("./components/url-modal"));
var get_customer_subscriptions_1 = require("./queries/get-customer-subscriptions");
var birthday_gift_1 = __importDefault(require("./sections/birthday-gift"));
var cancel_orders_1 = __importDefault(require("./sections/cancel-orders"));
var edit_bundle_1 = __importDefault(require("./sections/edit-bundle"));
var loyalty_1 = __importDefault(require("./sections/loyalty"));
var order_1 = __importDefault(require("./sections/orders/components/order"));
var payment_1 = __importDefault(require("./sections/payment/components/payment"));
var paymentGate_1 = __importDefault(require("./sections/payment/components/paymentGate"));
var profile_1 = __importDefault(require("./sections/profile/components/profile"));
var retention_offer_v2_1 = __importDefault(require("./sections/retention-offer-v2"));
var useMemo = React.useMemo;
exports.default = (function () {
    var _a = (0, react_query_1.useQuery)('getCustomerSubscriptions', function () {
        return (0, api_1.getSubscriptionAPIClient)()
            .request(get_customer_subscriptions_1.GetCustomerSubscriptions)
            .then(function (_a) {
            var getSubscriptions = _a.getSubscriptions, data = __rest(_a, ["getSubscriptions"]);
            return __assign(__assign({}, data), { 
                // we want to sort the subscriptions by order date, because we want to reference the zeroeth element in multiple places
                getSubscriptions: getSubscriptions.sort(function (aBundle, bBundle) {
                    return new Date(aBundle.subscription.next_charge_scheduled_at) >= new Date(bBundle.subscription.next_charge_scheduled_at) ? 0 : -1;
                }) });
        });
    }, {
        onSuccess: function (_a) {
            // as soon as the customer data is ready, change the account banner
            var _b, _c;
            var getSubscriptions = _a.getSubscriptions;
            // some customers have no bundles at all
            // TODO: why does typescript not know that getSubscriptions[number] could be undefined?
            var firstSubscription = getSubscriptions[0];
            if (!firstSubscription)
                return;
            var bundleComponents = new bundle_components_1.default(firstSubscription);
            var bundleType = bundleComponents.getBundleType();
            var bannerBundleType = (function () {
                switch (bundleType) {
                    case 'Diaper':
                        return 'diapers';
                    case 'Fundamentals':
                        return 'fundamentals';
                    case 'Training Pant':
                        return 'training_pants';
                    case 'Vitamin':
                        return 'vitamins';
                }
            })();
            (_c = (_b = window.announcementBarApp).changeBanner) === null || _c === void 0 ? void 0 : _c.call(_b, '/account', bannerBundleType);
        },
    }), data = _a.data, isLoading = _a.isLoading, customerLoadError = _a.error;
    if (customerLoadError) {
        console.debug("customerLoadError", customerLoadError);
        return (React.createElement("div", { className: 'grid-container' },
            React.createElement("div", { className: 'padding-vertical-10 bg-white text-center' }, "We are having some trouble loading your account. Please try again in a bit")));
    }
    var groupedSubscriptions = data === null || data === void 0 ? void 0 : data.getSubscriptions;
    var customerData = data === null || data === void 0 ? void 0 : data.getCustomer;
    var customerOrders = data === null || data === void 0 ? void 0 : data.getOrders;
    var accountPage = function () { return React.createElement(account_page_1.default, { customerData: customerData, groupedSubscriptions: groupedSubscriptions }); };
    var editBundlePage = function () { return React.createElement(edit_bundle_1.default, { customerData: customerData, groupedSubscriptions: groupedSubscriptions, isLoading: isLoading }); };
    var editProfilePage = function () { return React.createElement(profile_1.default, { customer: customerData }); };
    var paymentPage = function () { return React.createElement(payment_1.default, { customerData: customerData }); };
    var returnsApp = function () { return React.createElement(app_1.default, { customer: customerData }); };
    var ordersPage = function () { return React.createElement(order_1.default, { isLoadingAccountData: isLoading }); };
    var cancelOrderPage = function () { return React.createElement(cancel_orders_1.default, { isLoadingAccountData: isLoading, orders: customerOrders }); };
    // Payment gate has no switch via the CMS, so disabling it while we figure out how this works with ProfitWell.
    if ((customerData === null || customerData === void 0 ? void 0 : customerData.payment_failure) && false) {
        // Failed payment. Block with payment gate
        return (React.createElement(react_router_dom_1.HashRouter, null,
            React.createElement(callout_1.CalloutProvider, null,
                React.createElement(callout_1.Callout, null),
                React.createElement("div", { className: 'grid-x' },
                    React.createElement("div", { className: 'large-6 large-offset-3 small-12 columns' },
                        React.createElement(paymentGate_1.default, { customer: customerData }))))));
    }
    return (React.createElement(react_router_dom_1.HashRouter, null,
        React.createElement(devtools_1.ReactQueryDevtools, { initialIsOpen: false }),
        React.createElement(url_modal_1.default, null),
        React.createElement(retention_offer_v2_1.default, { groupedSubscriptions: groupedSubscriptions }),
        React.createElement(birthday_gift_1.default, null),
        React.createElement(loyalty_1.default, null),
        React.createElement(scroll_to_top_1.default, null),
        React.createElement(inline_loader_1.default, { isLoading: isLoading }),
        React.createElement(callout_1.CalloutProvider, null,
            React.createElement(callout_1.Callout, null),
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'large-6 large-offset-3 small-12 columns' },
                    React.createElement(react_router_dom_1.Switch, null,
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/', component: accountPage }),
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/orders', component: ordersPage }),
                        React.createElement(react_router_dom_1.Route, { path: '/orders/cancel/:orderId', component: cancelOrderPage }),
                        React.createElement(react_router_dom_1.Route, { path: '/edit-bundle', component: accountPage }),
                        React.createElement(react_router_dom_1.Route, { path: '/subscriptions/edit-items/:subId', component: editBundlePage }),
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/profile', component: editProfilePage }),
                        React.createElement(react_router_dom_1.Route, { path: '/payment', component: paymentPage }),
                        React.createElement(react_router_dom_1.Route, { path: '/returns', component: returnsApp })))))));
});
